import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import BrandMark from '../BrandMark';
import './BuzzerSolo.css';

export default function BuzzerSoloLandingPage() {
  const [tableCount, setTableCount] = useState(20);
  const [period, setPeriod] = useState('monthly');

  const total = useMemo(() => {
    const unit = period === 'yearly' ? 3 : 0.3;
    return (Number(tableCount || 0) * unit).toFixed(2);
  }, [tableCount, period]);

  return (
    <div className="bsolo-page">
      <div className="bsolo-shell">
        <div className="bsolo-brandbar">
          <BrandMark href="/" size={36} />
          <div className="bsolo-brandbar__actions">
            <Link className="bsolo-link-chip" to="/home">Back to homepage</Link>
            <Link className="bsolo-link-chip" to="/login">Use existing account</Link>
          </div>
        </div>

        <section className="bsolo-hero">
          <div>
            <div className="bsolo-pill bsolo-pill--accent">BuzzerFeedback Solo • EstiaSync service</div>
            <h1>Dynamic QR service calls and table feedback, in EstiaSync style.</h1>
            <p className="bsolo-muted bsolo-lead">
              Launch a fresh QR for every sitting, notify the right service staff instantly,
              and collect feedback at the end of the visit without loading the full reservations workflow.
            </p>

            <div className="bsolo-feature-grid">
              <div className="bsolo-feature">
                <div className="bsolo-meta">Security</div>
                <strong>Fresh QR on every sitting</strong>
              </div>
              <div className="bsolo-feature">
                <div className="bsolo-meta">Operations</div>
                <strong>Area-based waiter notifications</strong>
              </div>
              <div className="bsolo-feature">
                <div className="bsolo-meta">Insights</div>
                <strong>Ratings, emails and comments</strong>
              </div>
            </div>

            <div className="bsolo-actions">
              <Link className="bsolo-btn" to="/buzzerfeedback-solo/register">Create account &amp; activate Solo</Link>
              <Link className="bsolo-btn-secondary" to="/login">I already have an EstiaSync account</Link>
            </div>
            <div className="bsolo-meta" style={{ marginTop: 12 }}>
              New customers register first, then choose tables, pay online and activate Solo.
            </div>
          </div>

          <div className="bsolo-stack">
            <div className="bsolo-panel">
              <h3 style={{ marginTop: 0 }}>How it works</h3>
              <div className="bsolo-list">
                <div>1. Create your EstiaSync account for Solo.</div>
                <div>2. Enter your invoicing details and optional client branding.</div>
                <div>3. Choose monthly or yearly billing and how many tables you need.</div>
                <div>4. Pay online, activate Solo and start sittings with a fresh QR for each visit.</div>
              </div>
            </div>

            <div className="bsolo-panel">
              <h3 style={{ marginTop: 0 }}>Pricing calculator</h3>
              <div className="bsolo-field">
                <label>Tables</label>
                <input
                  type="number"
                  min="1"
                  value={tableCount}
                  onChange={(e) => setTableCount(Number(e.target.value || 0))}
                />
              </div>
              <div className="bsolo-actions" style={{ marginTop: 14 }}>
                <button className={period === 'monthly' ? 'bsolo-btn' : 'bsolo-btn-secondary'} onClick={() => setPeriod('monthly')}>Monthly</button>
                <button className={period === 'yearly' ? 'bsolo-btn' : 'bsolo-btn-secondary'} onClick={() => setPeriod('yearly')}>Yearly</button>
              </div>
              <div style={{ marginTop: 16, fontSize: '1.75rem', fontWeight: 800 }}>€{total}</div>
              <div className="bsolo-meta">{period === 'monthly' ? '0.30 €/table/month' : '3.00 €/table/year'}</div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
